import { fetchRequestWithTypes } from './index.js';

export const POST_ACCOUNT_BANK_ACCOUNT_REQUEST = 'POST_ACCOUNT_BANK_ACCOUNT_REQUEST';
export const POST_ACCOUNT_BANK_ACCOUNT_SUCCESS = 'POST_ACCOUNT_BANK_ACCOUNT_SUCCESS';
export const POST_ACCOUNT_BANK_ACCOUNT_ERRORED = 'POST_ACCOUNT_BANK_ACCOUNT_ERRORED';

export const postAccountBankAccount = (body: Record<string, unknown>) =>
	fetchRequestWithTypes({
		types: [
			POST_ACCOUNT_BANK_ACCOUNT_REQUEST,
			POST_ACCOUNT_BANK_ACCOUNT_SUCCESS,
			POST_ACCOUNT_BANK_ACCOUNT_ERRORED,
		],
		request: {
			method: 'POST',
			path: `/externalAccounts/api/v1/users/:uuid/link/legacy-micro/new`,
			body,
		},
	});

export const GET_MANAGE_EXTERNAL_ACCOUNT_REQUEST = 'GET_MANAGE_EXTERNAL_ACCOUNT_REQUEST';
export const GET_MANAGE_EXTERNAL_ACCOUNT_SUCCESS = 'GET_MANAGE_EXTERNAL_ACCOUNT_SUCCESS';
export const GET_MANAGE_EXTERNAL_ACCOUNT_ERRORED = 'GET_MANAGE_EXTERNAL_ACCOUNT_ERRORED';

export const getManageExternalAccount = () =>
	fetchRequestWithTypes({
		types: [
			GET_MANAGE_EXTERNAL_ACCOUNT_REQUEST,
			GET_MANAGE_EXTERNAL_ACCOUNT_SUCCESS,
			GET_MANAGE_EXTERNAL_ACCOUNT_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/externalAccounts/api/v1/users/:uuid/manageExternalBankAccount`,
		},
	});
